import { useInfiniteQuery } from "@tanstack/react-query";
import { PAGINATION } from "@unreserved/constants";
import type { GetNotificationsResponseDto } from "@unreserved/sdk";
import { notificationsApi } from "@unreserved/services";

const getNextPageParam = (lastPage: GetNotificationsResponseDto) => {
  const pagination = lastPage.data?.pagination;
  if (!pagination || pagination.pageNo >= pagination.totalPages) return undefined;
  return pagination.pageNo + 1;
};

export function useNotificationsInfinite({
  alwaysRefetch = false,
  enabled = true,
}: {
  alwaysRefetch?: boolean;
  enabled?: boolean;
} = {}) {
  return useInfiniteQuery<GetNotificationsResponseDto>({
    queryKey: ["notifications", "infinite"],
    queryFn: ({ pageParam }) =>
      notificationsApi.notificationControllerGetNotificationsV1({
        pageNo: (pageParam as number) ?? 1,
        pageSize: PAGINATION.DEFAULT_LIMIT,
      }),
    initialPageParam: 1,
    getNextPageParam,
    enabled,
    ...(alwaysRefetch && { refetchOnMount: "always" as const, staleTime: 0 }),
  });
}
